import { render } from "./ChessPage.vue?vue&type=template&id=6dcd1839"
import script from "./ChessPage.vue?vue&type=script&lang=js"
export * from "./ChessPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bitrix/ext_www/xn--80aabnf2cop.online/local/tools/baden-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__